export class OrderStatuses {
    public static PENDING = 'PENDING';
    public static RECEIVED = 'RECEIVED';
    public static READY = 'READY';
    public static PREPARING = 'PREPARING';
    public static DELIVERED = 'DELIVERED';
    public static CANCELED = 'CANCELED';
    public static VACATED = 'VACATED';
    public static DELETED = 'DELETED';

    static isActive(status: string) {
        return status === OrderStatuses.RECEIVED || status === OrderStatuses.PREPARING || status === OrderStatuses.READY;
    }
}
